import styled from 'styled-components';
import { COLORS, SHADOWS } from '@/theme';
import { Input, Select } from '@/ui';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.GREY94};
      padding: 1rem 0.5rem;
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledInput = styled(Input)`
  height: 2rem !important;
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;

export const StyledSelect = styled(Select)`
  height: 2rem !important;
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;
